module.exports = __webpack_public_path__ + "img/delete.3bf79325.svg";